import { Color } from '@joinforma/ui/constants/themes';

export const EXPLORE_ORIGINS = [
  'account_callout',
  'category_callout',
  'miso_product_page_recommendation',
  'miso_store_landing_recommendation',
] as const;

export const MINIMUM_SAVINGS_TO_DISPLAY = 0;

export const SIZE_OPTIONS = {
  SMALL: 'small',
  LARGE: 'large',
};

export const StyleOptions: {
  [size: string]: {
    border: string;
    headlineSize: string;
    imageBorderRadius: string;
    imageHeight: string;
    textSize: string;
    width: string;
  };
} = {
  [SIZE_OPTIONS.LARGE]: {
    border: `1px solid ${Color.GREY_50}`,
    headlineSize: '22px',
    imageBorderRadius: '6px 6px 0px 0px',
    imageHeight: '215px',
    textSize: '16px',
    width: '375px',
  },
  [SIZE_OPTIONS.SMALL]: {
    border: '0px',
    headlineSize: '18px',
    imageBorderRadius: '6px',
    imageHeight: '160px',
    textSize: '14px',
    width: '280px',
  },
};
